import React from "react";
import { useFela } from "react-fela";

import { IBlogCard } from "./types";
import { Card } from "../../components/Card";
import { useTheme } from "../../hooks/useTheme";
import { Heading } from "../../components/Heading";
import { Image } from "../../components/Image";

export const BlogCard: React.FC<IBlogCard> = ({
  title,
  content,
  media,
  href,
  buttonLabel,
}) => {
  const { css } = useFela();
  const { colors, bp } = useTheme();

  return (
    <Card
      customStyle={{
        maxWidth: 340,
        margin: "0 auto",
        alignItems: "flex-start",
        textAlign: "left",
        [bp.FROM_DESKTOP]: { minHeight: 440, maxWidth: 340, padding: 20 },
        [bp.FROM_LARGE_DESKTOP]: { minHeight: 440 },
      }}
    >
      <Image src={media.src} alt={media.alt} customStyle={{ width: "100%" }} />
      <Heading as="h3" customStyle={{ marginBottom: 16, marginTop: 16 }}>
        {title}
      </Heading>

      <p
        className={css({
          height: 88,
          overflow: "hidden",
          color: colors.GRAY,
          margin: "0 0 32",
          letterSpacing: 0.44,
        })}
      >
        {content}
      </p>

      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        className={css({
          letterSpacing: 0.44,
          color: colors.RED,
          textDecoration: "none",
        })}
      >
        {buttonLabel}
      </a>
    </Card>
  );
};
